import type { FieldMissionItem } from '@groupe-reca/contracts'
import { Lock } from 'lucide-react'
import { formatDuration as formatClock } from '@/features/detection/presentation/describeEvent'
import { itemAddress } from '../../domain/fieldText'

// Choix d'adresse : remplace temporairement le panneau gauche quand deux entrées sont indiscernables. La carte reste
// visible. Le choix confirme l'identité, pas le travail; « Aucune » ne change rien.

export interface AddressChoiceProps {
  candidates: FieldMissionItem[]
  active: { item: FieldMissionItem; observedMs: number } | null
  onChoose: (itemId: string) => void
  onNone: () => void
}

export function AddressChoice({ candidates, active, onChoose, onNone }: AddressChoiceProps) {
  return (
    <section className="op-choice" aria-labelledby="op-choice-title">
      {active ? (
        <p className="op-choice__kept">
          <Lock aria-hidden="true" /> Tâche active conservée : {itemAddress(active.item.snapshot)} ·{' '}
          {formatClock(active.observedMs)}
        </p>
      ) : null}
      <span className="op-focus__chip op-focus__chip--approach">Choix d’adresse</span>
      <h2 id="op-choice-title">Quelle entrée traitez-vous ?</h2>
      <p className="op-muted">
        Deux entrées sont trop proches pour être distinguées. Rien ne change tant que vous n’avez pas choisi.
      </p>
      <div className="op-choice__list">
        {candidates.map((item) => (
          <button
            key={item.id}
            type="button"
            className="op-choice__option"
            onClick={() => {
              onChoose(item.id)
            }}
          >
            <span className="op-order">{item.order}</span>
            <span className="op-choice__address">{itemAddress(item.snapshot)}</span>
            {item.snapshot.clientName ? <span className="op-choice__name">{item.snapshot.clientName}</span> : null}
          </button>
        ))}
        <button type="button" className="op-choice__option op-choice__option--none" onClick={onNone}>
          Aucune / Je passe seulement
        </button>
      </div>
      <p className="op-choice__foot">Le choix confirme l’adresse, pas le travail. À faire à l’arrêt.</p>
    </section>
  )
}
